import React, { memo, useCallback, useEffect } from 'react';

import { getTextField } from '@lender/utils';
import ModalFormWrapper from '@sharedCR/coreDesignSystem/ModalFormWrapper';
import { onAutocompleteChangeInForm } from 'app/shared/components/form/Autocomplete';
import { AutocompleteCDS } from 'app/shared/componentsRestyled/coreDesignSystem/form';
import withLoading, { WithLoadingPropTypes } from 'hocs/withLoading';
import { compose } from 'redux';
import { object } from 'yup';

import { argyleReportTypeOptions } from 'constants/loanActionEditor';
import useForm from 'hooks/useForm';

import { ArgyleIncomeVerificationFormTestIds } from './ArgyleIncomeVerificationForm.testIds';

const schema = object().shape({
  reportType: getTextField(),
});

const ArgyleIncomeVerificationForm = ({ isLoading, formRef, onSubmit }) => {
  const { form, setSchema, setInForm, isFormChanged, validateForm, validateField } = useForm({});

  useEffect(() => {
    setSchema(schema);
  }, [setSchema]);

  const onSubmitForm = useCallback(
    async e => {
      e.preventDefault();

      if (!(await validateForm())) {
        return;
      }

      onSubmit(form.reportType?.value);
    },
    [validateForm, form, onSubmit],
  );

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onAutocompleteChange = useCallback(
    onAutocompleteChangeInForm({ setInForm, validateField }),
    [setInForm, validateField],
  );

  return (
    <ModalFormWrapper
      formRef={formRef}
      formTestId="argyle-income-verification-form"
      isFormChanged={isFormChanged}
      isSubmitting={isLoading}
      submitButtonName="Submit"
      onSubmit={onSubmitForm}
    >
      <AutocompleteCDS
        disableClearable
        required
        containerClassName="mb-24"
        dataTestId={ArgyleIncomeVerificationFormTestIds.REPORT_TYPE_SELECT}
        disabled={isLoading}
        label="Report Type"
        name="reportType"
        options={argyleReportTypeOptions}
        value={form.reportType || ''}
        onChange={onAutocompleteChange}
      />
    </ModalFormWrapper>
  );
};

ArgyleIncomeVerificationForm.propTypes = {
  ...WithLoadingPropTypes,
};

export default compose(withLoading, memo)(ArgyleIncomeVerificationForm);
